export const priceToCurrency = (price) => {
  const nf = new Intl.NumberFormat('en', {
    minimumFractionDigits: 0,
    style: 'currency',
    currency: 'USD',
  })
  const num = nf.format(price / 100)
  return `${num}`
}

export const show = ($el) => {
  $el.removeClass('opacity-0 invisible').addClass('opacity-100 visible')
}
export const hide = ($el) => {
  $el.addClass('opacity-0 invisible').removeClass('opacity-100 visible')
}

export const hasVariants = (product) => {
  if (!product) {
    return false
  }
  const hasLength = product.variants.length > 0
  const notDefault = product.variants[0].title !== 'Default Title'
  return hasLength && notDefault
}
